// This file is auto-generated by @hey-api/openapi-ts

import type { Client, Options as Options2, TDataShape } from './client';
import { client } from './client.gen';
import {
  getExperienceListNewResponseTransformer,
  getExperienceListResponseTransformer,
  getExperiencesByIdsResponseTransformer,
  listTravelerOrdersResponseTransformer,
} from './transformers.gen';
import type {
  AddExperienceToFavoriteData,
  AddExperienceToFavoriteResponses,
  GetCityTagsData,
  GetCityTagsListData,
  GetCityTagsListErrors,
  GetCityTagsListResponses,
  GetCityTagsResponses,
  GetExperienceListData,
  GetExperienceListNewData,
  GetExperienceListNewResponses,
  GetExperienceListResponses,
  GetExperiencesByIdsData,
  GetExperiencesByIdsResponses,
  GetExperiencesFavoritesListData,
  GetExperiencesFavoritesListResponses,
  GetGeoObjectBySlugData,
  GetGeoObjectBySlugResponses,
  GetHeroListData,
  GetHeroListErrors,
  GetHeroListResponses,
  GetLandingCitiesListData,
  GetLandingCitiesListErrors,
  GetLandingCitiesListResponses,
  GetMainPageBlocksData,
  GetMainPageBlocksErrors,
  GetMainPageBlocksResponses,
  GetRegionsListData,
  GetRegionsListErrors,
  GetRegionsListResponses,
  GetReviewsListData,
  GetReviewsListErrors,
  GetReviewsListResponses,
  GetStatisticData,
  GetStatisticResponses,
  GetUserSubscriptionsData,
  GetUserSubscriptionsResponses,
  ListTravelerOrdersData,
  ListTravelerOrdersResponses,
  RemoveExperienceFromFavoriteData,
  RemoveExperienceFromFavoriteResponses,
  SearchSiteData,
  SearchSiteResponses,
  SubmitTravelerReviewData,
  SubmitTravelerReviewResponses,
  SubscribeData,
  SubscribeErrors,
  SubscribeResponses,
} from './types.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean> = Options2<
  TData,
  ThrowOnError
> & {
  /**
   * You can provide a client instance returned by `createClient()` instead of
   * individual options. This might be also useful if you want to implement a
   * custom client.
   */
  client?: Client;
  /**
   * You can pass arbitrary values through the `meta` object. This can be
   * used to access values that aren't defined as part of the SDK function.
   */
  meta?: Record<string, unknown>;
};

/**
 * Поиск по сайту
 *
 * ## Параметры
 *
 * - **query** текст запроса
 * - **limit** кол-во результатов
 * - **types** фильтр по типам объектов. Строка с запятой в качестве разделителя. Возможные значения:
 * city, country, citytag, experience
 */
export const searchSite = <ThrowOnError extends boolean = false>(options: Options<SearchSiteData, ThrowOnError>) =>
  (options.client ?? client).get<SearchSiteResponses, unknown, ThrowOnError>({ url: '/api/search/site/', ...options });

/**
 * Service statistic
 */
export const getStatistic = <ThrowOnError extends boolean = false>(options?: Options<GetStatisticData, ThrowOnError>) =>
  (options?.client ?? client).get<GetStatisticResponses, unknown, ThrowOnError>({ url: '/api/statistic/', ...options });

/**
 * Landing cities
 *
 * Landing cities list
 */
export const getLandingCitiesList = <ThrowOnError extends boolean = false>(
  options?: Options<GetLandingCitiesListData, ThrowOnError>,
) =>
  (options?.client ?? client).get<GetLandingCitiesListResponses, GetLandingCitiesListErrors, ThrowOnError>({
    url: '/api/web/v1/cities/landing/',
    ...options,
  });

/**
 * Get geo object
 */
export const getGeoObjectBySlug = <ThrowOnError extends boolean = false>(
  options: Options<GetGeoObjectBySlugData, ThrowOnError>,
) =>
  (options.client ?? client).get<GetGeoObjectBySlugResponses, unknown, ThrowOnError>({
    url: '/api/web/v1/cities/{geoObjectSlug}/',
    ...options,
  });

/**
 * Get city tags
 */
export const getCityTags = <ThrowOnError extends boolean = false>(options: Options<GetCityTagsData, ThrowOnError>) =>
  (options.client ?? client).get<GetCityTagsResponses, unknown, ThrowOnError>({
    url: '/api/web/v1/citytags/',
    ...options,
  });

/**
 * Получение списка экскурсий/туров в избранном
 */
export const getExperiencesFavoritesList = <ThrowOnError extends boolean = false>(
  options?: Options<GetExperiencesFavoritesListData, ThrowOnError>,
) =>
  (options?.client ?? client).get<GetExperiencesFavoritesListResponses, unknown, ThrowOnError>({
    url: '/api/web/v1/experiences/favorites/',
    ...options,
  });

/**
 * Удалить экспериенс из избранного
 */
export const removeExperienceFromFavorite = <ThrowOnError extends boolean = false>(
  options: Options<RemoveExperienceFromFavoriteData, ThrowOnError>,
) =>
  (options.client ?? client).delete<RemoveExperienceFromFavoriteResponses, unknown, ThrowOnError>({
    url: '/api/web/v1/experiences/{experienceId}/favorite/',
    ...options,
  });

/**
 * Добавить экспериенс в избранное
 */
export const addExperienceToFavorite = <ThrowOnError extends boolean = false>(
  options: Options<AddExperienceToFavoriteData, ThrowOnError>,
) =>
  (options.client ?? client).put<AddExperienceToFavoriteResponses, unknown, ThrowOnError>({
    url: '/api/web/v1/experiences/{experienceId}/favorite/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * CityTags
 *
 * CityTags list
 */
export const getCityTagsList = <ThrowOnError extends boolean = false>(
  options?: Options<GetCityTagsListData, ThrowOnError>,
) =>
  (options?.client ?? client).get<GetCityTagsListResponses, GetCityTagsListErrors, ThrowOnError>({
    url: '/api/web/v1/main-page/citytags/',
    ...options,
  });

/**
 * Experiences
 *
 * Main page experience list
 */
export const getExperienceList = <ThrowOnError extends boolean = false>(
  options?: Options<GetExperienceListData, ThrowOnError>,
) =>
  (options?.client ?? client).get<GetExperienceListResponses, unknown, ThrowOnError>({
    responseTransformer: getExperienceListResponseTransformer,
    url: '/api/web/v1/main-page/experiences/',
    ...options,
  });

/**
 * Articles
 *
 * Articles list
 */
export const getHeroList = <ThrowOnError extends boolean = false>(options?: Options<GetHeroListData, ThrowOnError>) =>
  (options?.client ?? client).get<GetHeroListResponses, GetHeroListErrors, ThrowOnError>({
    url: '/api/web/v1/main-page/hero/',
    ...options,
  });

/**
 * Regions
 *
 * Regions list
 */
export const getRegionsList = <ThrowOnError extends boolean = false>(
  options?: Options<GetRegionsListData, ThrowOnError>,
) =>
  (options?.client ?? client).get<GetRegionsListResponses, GetRegionsListErrors, ThrowOnError>({
    url: '/api/web/v1/main-page/regions-tours/',
    ...options,
  });

/**
 * Reviews
 *
 * Reviews list
 */
export const getReviewsList = <ThrowOnError extends boolean = false>(
  options?: Options<GetReviewsListData, ThrowOnError>,
) =>
  (options?.client ?? client).get<GetReviewsListResponses, GetReviewsListErrors, ThrowOnError>({
    url: '/api/web/v1/main-page/reviews/',
    ...options,
  });

/**
 * Получить все заказы путешественника
 */
export const listTravelerOrders = <ThrowOnError extends boolean = false>(
  options?: Options<ListTravelerOrdersData, ThrowOnError>,
) =>
  (options?.client ?? client).get<ListTravelerOrdersResponses, unknown, ThrowOnError>({
    responseTransformer: listTravelerOrdersResponseTransformer,
    url: '/api/web/v1/orders/',
    ...options,
  });

/**
 * Get user subscriptions
 */
export const getUserSubscriptions = <ThrowOnError extends boolean = false>(
  options?: Options<GetUserSubscriptionsData, ThrowOnError>,
) =>
  (options?.client ?? client).get<GetUserSubscriptionsResponses, unknown, ThrowOnError>({
    url: '/api/web/v1/subs/check/',
    ...options,
  });

/**
 * Subscribe
 */
export const subscribe = <ThrowOnError extends boolean = false>(options: Options<SubscribeData, ThrowOnError>) =>
  (options.client ?? client).post<SubscribeResponses, SubscribeErrors, ThrowOnError>({
    url: '/api/web/v1/subs/subscribe/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Get experiences by IDs
 *
 * Get experiences list by comma-separated IDs
 */
export const getExperiencesByIds = <ThrowOnError extends boolean = false>(
  options: Options<GetExperiencesByIdsData, ThrowOnError>,
) =>
  (options.client ?? client).get<GetExperiencesByIdsResponses, unknown, ThrowOnError>({
    responseTransformer: getExperiencesByIdsResponseTransformer,
    url: '/api/web/v2/experiences/',
    ...options,
  });

/**
 * Experiences
 *
 * Main page experience list
 */
export const getExperienceListNew = <ThrowOnError extends boolean = false>(
  options?: Options<GetExperienceListNewData, ThrowOnError>,
) =>
  (options?.client ?? client).get<GetExperienceListNewResponses, unknown, ThrowOnError>({
    responseTransformer: getExperienceListNewResponseTransformer,
    url: '/api/web/v2/experiences/?limit=6&offset=0&promo=true&type=private,group,ticket&price_format=travelers&extended_movement_types=true&photos_count=1',
    ...options,
  });

/**
 * Создать отзыв путешественника
 */
export const submitTravelerReview = <ThrowOnError extends boolean = false>(
  options: Options<SubmitTravelerReviewData, ThrowOnError>,
) =>
  (options.client ?? client).post<SubmitTravelerReviewResponses, unknown, ThrowOnError>({
    url: '/api/web/v2/traveler-review/{review_hash}/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Get main page blocks
 *
 * Returns all blocks for the main page including guides, articles, and seasonal content
 */
export const getMainPageBlocks = <ThrowOnError extends boolean = false>(
  options?: Options<GetMainPageBlocksData, ThrowOnError>,
) =>
  (options?.client ?? client).get<GetMainPageBlocksResponses, GetMainPageBlocksErrors, ThrowOnError>({
    url: '/service/landings/api/bff/v1/main-page',
    ...options,
  });
